module.exports = __webpack_public_path__ + "img/NinjaLook3.4687f109.png";